import React from 'react'

import TextInput from 'components/Input/TextInput'

const InputComponent = ({ meta, input, ...rest }) => (
  <TextInput meta={meta} {...input} {...rest} />
)

export default InputComponent
